var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEtools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140.27 37.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dadada;}.cls-2{fill:#c00000;}.cls-3{fill:#666;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fichier 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fond_\\xE9cran",
    "data-name": "Fond \\xE9cran"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.48,30.94a6.54,6.54,0,0,1-6.54,6.54H6.54A6.54,6.54,0,0,1,0,30.94V6.55A6.55,6.55,0,0,1,6.54,0h24.4a6.55,6.55,0,0,1,6.54,6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25,21.2a16.2,16.2,0,0,0,7.3-8.74,4.43,4.43,0,0,0-2-5.49C23.13,4.12,14.15,5.31,9,12,5.4,16.73,2.59,25.36,7.64,29.65c5.62,3.39,12.12,2.56,18,.65,1.58-.47,2.92-2.85,3.38-5-4.72.24-10,2.32-14.37,0-2.3-2.2-.9-5.47,0-8.09,1.12-2.62,2.69-5,4.93-6.19,1.81-.95,4.61-1.25,5.62.48.11,1.78-6.06,6.18-9.88,9-.22.24,0,.78.23.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.32,33a6.23,6.23,0,0,1-4.8-1.78Q45.84,29.44,45.83,16H41.92V11.75h3.91V4h5.6v7.73h6V16h-6v8.59a4.94,4.94,0,0,0,.73,3,3.52,3.52,0,0,0,2.13,1.09,15.7,15.7,0,0,0,2.3.12h.84V33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.71,30.33a11.09,11.09,0,0,1-8.14,3.1,11.19,11.19,0,0,1-8.14-3.06,10.64,10.64,0,0,1-3.14-8,10.6,10.6,0,0,1,3.14-8,11.29,11.29,0,0,1,3.63-2.29,12.2,12.2,0,0,1,4.51-.77,11.11,11.11,0,0,1,8.14,3,10.88,10.88,0,0,1,3.1,8A10.84,10.84,0,0,1,78.71,30.33ZM74.64,17.88a4.61,4.61,0,0,0-4-1.9,5.09,5.09,0,0,0-4.15,1.94,7.18,7.18,0,0,0-1.33,4.51,7.32,7.32,0,0,0,1.41,4.51,4.67,4.67,0,0,0,4,1.9A5,5,0,0,0,74.6,26.9,7.07,7.07,0,0,0,76,22.39,7.57,7.57,0,0,0,74.64,17.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.24,30.33a12.28,12.28,0,0,1-16.27,0,10.61,10.61,0,0,1-3.15-8,10.57,10.57,0,0,1,3.15-8,11.36,11.36,0,0,1,3.62-2.29,12.2,12.2,0,0,1,4.51-.77,11.09,11.09,0,0,1,8.14,3,10.84,10.84,0,0,1,3.1,8A10.8,10.8,0,0,1,103.24,30.33ZM99.17,17.88a4.6,4.6,0,0,0-4-1.9A5.09,5.09,0,0,0,91,17.92a7.24,7.24,0,0,0-1.33,4.51,7.32,7.32,0,0,0,1.41,4.51,4.67,4.67,0,0,0,4,1.9,5,5,0,0,0,4.07-1.94,7,7,0,0,0,1.37-4.51A7.5,7.5,0,0,0,99.17,17.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.73,33V4h5.8V33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M138.74,30.85A5.06,5.06,0,0,1,134.42,33H120v-4.4h11.81a3.88,3.88,0,0,0,2-.4,2,2,0,0,0,0-3.38,4.75,4.75,0,0,0-2.18-.41l-3.34.05h-.64c-.76,0-1.32,0-1.7-.05h-.12c-.78,0-1.45-.12-2-.2a5.58,5.58,0,0,1-2.34-.8,3.86,3.86,0,0,1-1.45-2,14,14,0,0,1-.44-3.9,5.18,5.18,0,0,1,2-4.07q2-1.65,17.53-1.66v4.4h-9.91a10.21,10.21,0,0,0-2.54.16,1.89,1.89,0,0,0-1.29,2c0,1.13,1,1.69,3.06,1.69l6.21.12c2.47.33,4.15,1.4,5,3.23a9.17,9.17,0,0,1,.57,3.38A7.09,7.09,0,0,1,138.74,30.85Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEtools);
export default __webpack_public_path__ + "static/media/logo_etools.b538f86b5c5c4c03e6f34de4604289be.svg";
export { ForwardRef as ReactComponent };